function getImageUrl(image, size = 'small') {
  if (!image?.url) return null;

  let path = image.url;
  if (path.startsWith('http')) {
    try {
      path = new URL(path).pathname;
    } catch (err) {
      console.error('Invalid URL:', path, err);
      return null;
    }
  }

  const isStaging = process.env.ENVIRONMENT === 'staging';
  const dims = size === 'big'
    ? { w: 1100, h: 800 }
    : { w: 400, h: 300 };

  const base = isStaging
    ? `https://images.staging.parkos.com/insecure/w:${dims.w}/h:${dims.h}/plain/`
    : `https://images.parkos.com/insecure/w:${dims.w}/h:${dims.h}/plain/`;

  const host = isStaging
    ? 'https://staging.assets.parkos.com'
    : 'https://assets.parkos.com';

  return `${base}${host}${path}@webp`;
}

export default getImageUrl;
